import { render, staticRenderFns } from "./jsaTargetProcessDetail.vue?vue&type=template&id=0c2df741"
import script from "./jsaTargetProcessDetail.vue?vue&type=script&lang=js"
export * from "./jsaTargetProcessDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c2df741')) {
      api.createRecord('0c2df741', component.options)
    } else {
      api.reload('0c2df741', component.options)
    }
    module.hot.accept("./jsaTargetProcessDetail.vue?vue&type=template&id=0c2df741", function () {
      api.rerender('0c2df741', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/jsa/plan/jsaTargetProcessDetail.vue"
export default component.exports